//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "EditTermDialog",
  components: {},
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      show: false,
      isEdit: true,
      form: {
        wid: "",
        schoolyear: "",
        semester: "1",
        starttime: null,
        endtime: null,
        explains: ""
      },
      rules: {
        schoolyear: [{
          required: true,
          message: "请输入学期",
          trigger: "blur"
        }],
        semester: [{
          required: true,
          message: "请选择学期",
          trigger: "blur"
        }],
        starttime: [{
          required: true,
          message: "请选择开学时间",
          trigger: "blur"
        }],
        endtime: [{
          required: true,
          message: "请选择结束时间",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    newData: function newData() {
      var _this = this;

      this.loading = true;
      this.$http.post("/calendar/save", JSON.stringify(this.form), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == "0") {
          _this.$message.success(data.resMsg);

          _this.show = false;

          _this.$emit("init-page");
        }

        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    edidData: function edidData() {
      var _this2 = this;

      this.loading = true;
      this.$http.post("/calendar/update", JSON.stringify(this.form), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == "0") {
          _this2.$message.success(data.resMsg);

          _this2.show = false;

          _this2.$emit("fetch-list");
        }

        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    validate: function validate() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this3.isEdit) {
            // 修改
            _this3.edidData();
          } else {
            // 新增
            _this3.newData();
          }
        } else {
          return false;
        }
      });
    },
    showView: function showView(item, isEdit) {
      var _this4 = this;

      this.isEdit = isEdit;
      this.show = true;

      if (item) {
        this.form.wid = item.wid;
        this.form.schoolyear = item.schoolyear;
        this.form.semester = item.semester;
        this.form.starttime = this.$options.filters.filterDate(item.starttime, "yyyy-MM-dd");
        this.form.endtime = this.$options.filters.filterDate(item.endtime, "yyyy-MM-dd");
        this.form.explains = item.explains;
      } else {
        this.$nextTick(function () {
          _this4.$refs.ruleForm.resetFields();
        });
      }
    }
  }
};